<template>
    <div class="converter">
        <Title firstName="逆变器概况" lastName="CONVERTER PROFILE" />
        <div class="content">
            <div class="con">
                <div class="nibian" v-for="item in loops" :key="item.deviceId">
                    <p>{{item.loopName}}</p>
                    <p>日发电量(kWh)：<span>{{isNaN(Number(mqtt[item.subLoopUrl +'/Daily_Power_Generation']))? 0 :Number(mqtt[item.subLoopUrl +'/Daily_Power_Generation']).toFixed(2)}}</span></p>
                    <p>总有功功率(W)：<span>{{isNaN(Number(mqtt[item.subLoopUrl +'/P']))? 0 :Number(mqtt[item.subLoopUrl +'/P']).toFixed(2)}}</span></p>
                </div>
            </div>
            <div class="page">
                <span class="pleft"><img src="../../../assets/img/pageLeft.png" alt=""></span>
                <span class="peleft"><img src="../../../assets/img/pageback.png" alt=""></span>
                <i>1/1</i>
                <span class="peleft"><img src="../../../assets/img/pageback.png" alt=""></span>
                <span class="pleft"><img src="../../../assets/img/pageLeft.png" alt=""></span>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title')
import { mapState } from 'vuex'

export default {
    props:['areaId'],
    data(){
        return {
            seriesData:[],
            loops:[]
        }
    },
    components:{
        Title,
    },
    watch: {
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'}),
        weather(){
            return this.$store.state.Cang.weather
        },
        sum(){
            let sum = 0
            this.seriesData.forEach(item =>{
                sum += item
            })
            return sum 
        },
        bian(){
            return (this.sum * (1/6)).toFixed(2)
        },
        bian2(){
            return (this.sum * (5/6)).toFixed(2)
        }
    },
    mounted(){
        if(this.areaId){
            this.getinverter()
        }
    },
    methods:{
        async getinverter(){
            let data = {
                areaId :this.areaId
            }
            let res = await this.$http.getinverterarea(data)
            console.log(res);
            this.loops = res.data.data.loops
        }
    },
}
</script>

<style lang="less" scoped>
    .converter{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 37.8vh;
        right: 1vw;

        .content{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            .con{
                padding: 2vh 0.6vw  3.5vh ;
                display: flex;
                justify-content: space-between;
                align-content: space-between;
                flex-wrap: wrap;
                height: 100%;
                .nibian{
                    width: 9.2vw;
                    height: 8.8vh;
                    padding:1vh 0 1vh 1.4vh;
                    font-size: 13rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    background-color: rgba(164,209,255, 0.12);
                    p{
                        span{
                            font-size: 18rem;
                            color:#00DEFF ;
                            font-family: zcoolqingkehuangyouti;
                        }
                    }
                    p:nth-of-type(2){
                        padding-top:1vh ;
                    }
                    p:nth-of-type(3){
                        padding-top:0.3vh ;
                        letter-spacing: 0.2rem;
                    }
                    
                }
            }
            
            .page{
                width: 100%;
                // height: 2vh;
                position: absolute;
                bottom: 1.5vh;
                left: 0;
                text-align: right;
                padding-right: 0.7vw;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.7);
                
                span{
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;
                }
                .pleft{
                    width: 20rem;
                    height: 18rem;
                    img{
                        width: 100%;
                        height: 100%;

                    }
                }
                .peleft{
                    width: 18rem;
                    height: 18rem;
                    margin: 0 10rem 0 4rem ;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .pleft:nth-of-type(1){
                    transform: rotate(180deg);
                }
                .peleft:nth-of-type(3){
                    transform: rotate(180deg);
                    margin: 0 4rem 0 10rem;
                }
                i{
                    font-style: normal;
                    vertical-align: middle;
                    
                }
            }
            
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>